import { createApi, createBaseQuery } from '@adv-frontend/modules-query';
import { apiV1Request } from '#shared/api/requests';
import {
    OpenApiDeleteJivoWidgetMethod,
    type OpenApiDeleteJivoWidgetRequest,
    type OpenApiDeleteJivoWidgetResponseSuccess,
    OpenApiDeleteJivoWidgetUrl,
    OpenApiGetJivoCredentialsMethod,
    type OpenApiGetJivoCredentialsRequest,
    type OpenApiGetJivoCredentialsResponseSuccess,
    OpenApiGetJivoCredentialsUrl,
    OpenApiGetJivoWidgetMethod,
    type OpenApiGetJivoWidgetRequest,
    type OpenApiGetJivoWidgetResponseSuccess,
    OpenApiGetJivoWidgetsMethod,
    type OpenApiGetJivoWidgetsResponseSuccess,
    type OpenApiGetJivoWidgetsSearchParams,
    OpenApiGetJivoWidgetsUrl,
    OpenApiGetJivoWidgetUrl,
    OpenApiSetupJivoWidgetMethod,
    type OpenApiSetupJivoWidgetRequest,
    type OpenApiSetupJivoWidgetResponseSuccess,
    OpenApiSetupJivoWidgetUrl,
} from '#shared/api/schema';

const api = createApi({
    name: 'entities/integration/api/jivoApi',
    baseQuery: createBaseQuery(apiV1Request),
    endpoints: (builder) => {
        return {
            getJivoCredentials: builder.query<
                OpenApiGetJivoCredentialsResponseSuccess,
                OpenApiGetJivoCredentialsRequest
            >({
                query: () => {
                    return {
                        url: OpenApiGetJivoCredentialsUrl,
                        method: OpenApiGetJivoCredentialsMethod,
                    };
                },
                keepUnusedDataFor: 0,
            }),
            getJivoWidgets: builder.query<OpenApiGetJivoWidgetsResponseSuccess, OpenApiGetJivoWidgetsSearchParams>({
                query: (params) => {
                    return {
                        url: OpenApiGetJivoWidgetsUrl,
                        method: OpenApiGetJivoWidgetsMethod,
                        params,
                    };
                },
                keepUnusedDataFor: 0,
            }),
            getJivoWidget: builder.query<OpenApiGetJivoWidgetResponseSuccess, OpenApiGetJivoWidgetRequest>({
                query: () => {
                    return {
                        url: OpenApiGetJivoWidgetUrl,
                        method: OpenApiGetJivoWidgetMethod,
                    };
                },
            }),
            setupJivoWidget: builder.mutation<OpenApiSetupJivoWidgetResponseSuccess, OpenApiSetupJivoWidgetRequest>({
                query: (payload) => {
                    return {
                        url: OpenApiSetupJivoWidgetUrl,
                        method: OpenApiSetupJivoWidgetMethod,
                        body: payload,
                    };
                },
            }),
            deleteJivoWidget: builder.mutation<OpenApiDeleteJivoWidgetResponseSuccess, OpenApiDeleteJivoWidgetRequest>({
                query: () => {
                    return {
                        url: OpenApiDeleteJivoWidgetUrl,
                        method: OpenApiDeleteJivoWidgetMethod,
                    };
                },
            }),
        };
    },
});

export const useIntegrationGetJivoWidgetQuery = api.useGetJivoWidgetQuery;
export const integrationJivoCredentialsGet = api.endpoints.getJivoCredentials.query;
export const integrationJivoWidgetsGet = api.endpoints.getJivoWidgets.query;
export const setupIntegrationJivoWidget = api.endpoints.setupJivoWidget.mutate;
export const deleteIntegrationJivoWidget = api.endpoints.deleteJivoWidget.mutate;
